<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="Heading-1" id="_idParaDest-7"><a id="_idTextAnchor007"></a>Language to Live In</h1>
<p class="E-pigraph-source-space"><em class="italic">For Janet and Peter Brav</em></p>
<p class="Verse-new">Codes everywhere clamoring to be cracked.</p>
<p class="Verse-main">Crack ’em and you get oozes of –<em class="italic">isms</em>,</p>
<p class="Verse-main">Lubricated by lies bought and paid for.</p>
<p class="Verse-new">Men live in armories they call their homes</p>
<p class="Verse-main">As likely to kill their wives and children</p>
<p class="Verse-main">As the men they believe would do it first,</p>
<p class="Verse-new">Hate cancered in so far pain’s a habit</p>
<p class="Verse-main">No drug can soothe withdrawal from—</p>
<p class="Verse-main">Murder makes sense (no language to live in).</p>
<p class="Verse-new">Those who buy their way out of suffering</p>
<p class="Verse-main">Never go as far as they think they will.</p>
<p class="Verse-main">The distance trivializes light-years.</p>
<p class="Verse-new">The unbearable truth: the only way out</p>
<p class="Verse-main">Is within—there’s no place else to go.</p>
<p class="Verse-main">Once religion guided believers there,</p>
<p class="Verse-new">But then Toto ran behind the curtain,</p>
<p class="Verse-main">And people finally got it: <em class="italic">man’s best friend</em></p>
<p class="Verse-main">(Of whom the sad ex-pat Christian incanted,</p>
<p class="Verse-new">‘Oh, keep the Dog far hence, that’s friend to men,</p>
<p class="Verse-main">Or with his nails he’ll dig it up again!’</p>
<p class="Verse-main">Lines so easy to forget and let go to waste).</p>
<p class="Verse-new">The dog, primitive cultures tell, teaches men</p>
<p class="Verse-main">How to be human. Just another code?</p>
<p class="Verse-main">Sure, but so simple it bears examining.</p>
<p class="Verse-new">The animal comes first. Born of a female,</p>
<p class="Verse-main">Issue of sex, sweeter than sin (Cringe? You should.),</p>
<p class="Verse-main">In need of gentleness, like every beast;</p>
<p class="Verse-main">Deprive it, and the animal bursts out at last,</p>
<p class="Verse-main">Anxious and savage and unable to endure</p>
<p class="Verse-main">Human envy no language to live in.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB-7.vue?4a43a98a